var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { namespace } from 'vuex-class';
import Vue from 'vue';
import Component from 'vue-class-component';
import BreakInDamageDescriptionSectionCard from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionSectionCard.vue';
import BreakInDamageDescriptionStep from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionStep.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import { parseLength } from '@declaration/helpers/typeFormatters';
import { GARAGE_DOOR_WIDTH_CHOICES } from '@shared/constants/breakInDamages/GarageDoorConstants';
import { GARAGE_DOOR_IS_MOTORIZED_CHOICES } from '@declaration/constants/breakInDamages/GarageDoorConstants';
const layout = namespace('layout');
const breakInDamage = namespace('breakInDamage');
let GarageDoorSizeAndMotorization = class GarageDoorSizeAndMotorization extends Vue {
    constructor() {
        super(...arguments);
        this.parseLength = parseLength;
        this.showValidation = false;
        this.GARAGE_DOOR_WIDTH_CHOICES = GARAGE_DOOR_WIDTH_CHOICES;
        this.GARAGE_DOOR_IS_MOTORIZED_CHOICES = GARAGE_DOOR_IS_MOTORIZED_CHOICES;
    }
    get change() {
        return this.changeGetter(this.changeKey);
    }
    get breakInDamage() {
        return this.change.data;
    }
    get validation() {
        return this.validationGetter(this.changeKey);
    }
    get isValid() {
        return (!this.validation.fieldHasViolations('garageDoorWidth') &&
            !this.validation.fieldHasViolations('garageDoorIsMotorized'));
    }
    update(data) {
        this.updateBreakInDamage({ changeKey: this.changeKey, data });
    }
    save() {
        this.$emit('goToNextStep');
    }
    revealValidation() {
        this.$store.dispatch('error/add', this.$tc('error.form.please_validate_message'));
        this.validateBreakInDamage(this.changeKey);
        this.showValidation = true;
    }
};
__decorate([
    layout.State('color')
], GarageDoorSizeAndMotorization.prototype, "color", void 0);
__decorate([
    breakInDamage.Getter('change')
], GarageDoorSizeAndMotorization.prototype, "changeGetter", void 0);
__decorate([
    breakInDamage.Action('updateDamage')
], GarageDoorSizeAndMotorization.prototype, "updateBreakInDamage", void 0);
__decorate([
    breakInDamage.Getter('validation')
], GarageDoorSizeAndMotorization.prototype, "validationGetter", void 0);
__decorate([
    breakInDamage.Action('validateAndRevealDamages')
], GarageDoorSizeAndMotorization.prototype, "validateBreakInDamage", void 0);
GarageDoorSizeAndMotorization = __decorate([
    Component({
        components: {
            BreakInDamageDescriptionStep,
            BreakInDamageDescriptionSectionCard,
            RadioPrimaryButton,
        },
        props: {
            changeKey: { type: [String, Number], default: null },
            isFinalStep: { type: Boolean, default: false },
            isSaving: { type: Boolean, default: false },
        },
    })
], GarageDoorSizeAndMotorization);
export default GarageDoorSizeAndMotorization;
